
export default {
  data() {
    return {
      valid: true,
      loading: false,
      btnIcon: false,
      email: '',
      emailRules: [
        (v) => !!v || 'E-mail is required',
        (v) => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ],
    }
  },
  methods: {
    async subscribe() {
      // console.log('Netlify functions', 'before', this.email)

      let me = this
      me.loading = true

      // Prevent complete blocking
      setTimeout(function () {
        me.resetFailure()
      }, 8000)

      try {
        const response = await me.$axios.$post(
          '.netlify/functions/newsletter-subscription',
          {
            email: me.email,
          }
        )

        console.debug('Netlify functions', 'after', response)

        if (response) {
          me.resetSuccess()

          return true
        }
      } catch (e) {
        console.error(e)
      }
    },
    resetSuccess() {
      const me = this

      me.loading = false
      me.btnIcon = true

      // Prevent complete blocking
      setTimeout(function () {
        me.btnIcon = false
        me.loading = false

        me.$refs.form.reset()
      }, 1000)
    },
    resetFailure() {
      this.loading = false
    },
  },
}
